<template lang="pug">
.initiating.text-white.rounded-4
  nuxt-img.bg(
    :src="image",
    :alt="`${title}`",
    fit="cover",
    loading="lazy",
  )
  .info
    EcreativArchetypesHeading.title(
      tag="h3",
      context="white"
    ) {{ title }}

    EcreativArchetypesHeading.subTitle.mb-4(
      tag="h4",
      size="5",
      context="white"
    ) {{ subTitle }}

    .body-text
      .col(v-for="(item, index) in props.items", :key="index")
        EcreativArchetypesHeading.mb-3(
          tag="h5",
          size="6",
          context="white"
        ) {{ item.subTitle }}
        EcreativArchePrimitivesParagraph.text.mb-4(
          context="white"
        ) {{ item.text }}
        .item-cta(v-if="item.link")
          EcreativArchetypesInteractiveArchetype(
            componentType="InternalDestination"
            :link="item.link",
            context="white",
            linkColor="dark",
            fontWeight="bold",
            text="Read More"
            class="fw-bold justify-content-center"
            isUnderLine="none"
            size="sm"
          )

    .cta(v-if="link")
      EcreativArchetypesInteractiveArchetype(
        componentType="InternalDestination"
        :link="link",
        context="white",
        linkColor="dark",
        fontWeight="bold",
        text="Read More"
        class="fw-bold justify-content-center"
        isUnderLine="none"
        size="lg"
      )
</template>

<script setup lang="ts">
/* eslint-disable */
import EcreativArchetypesHeading from '../archetypes/Heading';
import EcreativArchePrimitivesParagraph from '../arche/primitives/Paragraph';
import EcreativArchetypesInteractiveArchetype from '../archetypes/InteractiveArchetype';

type Item = {
  subTitle: string;
  text: string;
  link?: string;
};

const props = withDefaults(
  defineProps<{
    image?: string;
    title?: string;
    subTitle?: string;
    items: Item[];
    link?: string;
  }>(),
  {
    items: () => [],
  },
);
</script>

<style lang="scss" scoped>
.initiating {
  position: relative;
  overflow: hidden;
  height: 100%;
  aspect-ratio: 16/11;

  > .bg {
    position: absolute;
    object-fit: cover;
    width: 100%;
    height: 100%;
    inset: 0;
    border-radius: inherit;
  }

  @include media-breakpoint-up(sm) {
    height: 520px;
    aspect-ratio: unset;
  }

  @include media-breakpoint-up(lg) {
    height: 620px;
  }

  @include media-breakpoint-up(xl) {
    height: 720px;
  }
}

.info {
  position: absolute;
  display: grid;
  grid-template-columns: 1fr;
  grid-auto-rows: max-content;
  gap: clamp(8px, 1.5vw, 16px);
  align-content: start;
  padding: clamp(12px, 2.5vw, 40px);
  inset: 0;

  @include media-breakpoint-up(lg) {
    grid-template-columns: repeat(12, 1fr);
    column-gap: clamp(12px, 2vw, 32px);
  }
}

.title {
  margin: 0;
  font-size: clamp(30px, 4.5vw, 56px);
  line-height: 1.05;

  @include media-breakpoint-up(lg) {
    grid-column: 1 / span 13;
  }
}

.subTitle {
  margin: 0 0 clamp(8px, 1.2vw, 16px);
  font-size: clamp(16px, 2.2vw, 28px);

  @include media-breakpoint-up(lg) {
    grid-column: 1 / span 8;
  }
}

.body-text {
  display: grid;
  grid-template-columns: 1fr;
  gap: clamp(10px, 2vw, 28px);

  @include media-breakpoint-up(lg) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    grid-column: 1 / span 10;
  }
}

.col {
  display: flex;
  flex-direction: column;
}

.text {
  display: none;

  @include media-breakpoint-up(lg) {
    display: block;
  }
}

.item-cta {
  display: none;
  margin-top: auto;

  @include media-breakpoint-up(lg) {
    display: block;
  }
}

.cta {
  margin-top: clamp(8px, 1.5vw, 20px);

  @include media-breakpoint-up(lg) {
    display: none; // Hide main CTA on desktop if items have their own buttons
    grid-column: 1 / span 4;
  }
}
</style>
